const ContentWithImage = ({ props }) => {
  
  return (
    <div className="content-with-image">
      <div className="left-col">
        {props.content && (
          <div dangerouslySetInnerHTML={{ __html: props.content }}></div>
        )}
        {props.sectionOne.list && (
          <>
            {props.sectionOne.listTitle && <p>{props.sectionOne.listTitle}</p>}

            <ul>
              {props.sectionOne.list.map((item, idx) => (
                <li key={idx} dangerouslySetInnerHTML={{ __html: item }}></li>
              ))}
            </ul>
          </>
        )}

        {props.sectionOne.content && (
          <>
            {props.sectionOne.title && <h3>{props.sectionOne.title}</h3>}
            {props.sectionOne.content && (
              <div
                dangerouslySetInnerHTML={{ __html: props.sectionOne.content }}
              />
            )}
          </>
        )}

        {props.sectionTwo.list && (
          <>
            <p>{props.sectionTwo.listTitle}</p>
            <ul>
              {props.sectionTwo.list.map((item, idx) => (
                <li key={idx} dangerouslySetInnerHTML={{ __html: item }}></li>
              ))}
            </ul>
          </>
        )}
        {props.sectionTwo.content && (
          <>
            {props.sectionTwo.title && <h3>{props.sectionTwo.title}</h3>}
            {props.sectionTwo.content && (
              <div
                dangerouslySetInnerHTML={{ __html: props.sectionTwo.content }}
              />
            )}
          </>
        )}
      </div>
      <div className="right-col">
        <img
          src={`${process.env.PUBLIC_URL}${process.env.NODE_ENV === `production` ? `/build` : ``}/images/${props.image}`}
          alt=""
        />
      </div>
    </div>
  );
};

export default ContentWithImage;
